export const ERROR_MESSAGE_DEFAULT = 'Произошла неизвестная ошибка. Обратитесь в службу поддержки.'
export const UNKNOWN_ERROR_MESSAGE = 'Произошла неизвестная ошибка. Пожалуйста, повторите попытку позже.'

export const ErrorMessages = {
  GET_DATA_API: 'Не удалось загрузить данные',
  PASSWORDS_IS_NOT_EQUAL: 'Пароли не совпадают',
}
